import {
  platformIncludesMeta,
  platformIncludesGoogle,
} from 'components/Recommendations/Campaign/platform'
// e.g.: {
//   tc: 'some_tc',
//   tc_run_id: 'some_run_id',
//   fb: { ... },
//   google: { ... }
// }
export function buildTargetingSkeleton(selectedCampaigns, platform, existingTargeting = []) {
  const includesMeta = platformIncludesMeta(platform)
  const includesGoogle = platformIncludesGoogle(platform)

  return selectedCampaigns.map(({ tc, tc_run_id }) => {
    const existing = (existingTargeting ?? []).find((entry) => entry.tc === tc)
    const entry = { tc, tc_run_id }

    if (includesMeta) entry.fb = existing?.fb ?? {}
    if (includesGoogle) entry.google = existing?.google ?? {}

    return entry
  })
}
